export default __webpack_public_path__ + "e761e0b6928f87b119b7a9a57f6722c8.png";